import { yupResolver } from '@hookform/resolvers/yup'
import { Box, Typography } from '@material-ui/core'
import Container from '@material-ui/core/Container'
import CssBaseline from '@material-ui/core/CssBaseline'
import Link from '@material-ui/core/Link'
import { makeStyles } from '@material-ui/core/styles'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory, useParams } from 'react-router-dom'
import { Button } from 'src/components/ui/Button'
import { SynRoutes } from 'src/core/consts/synRoutes'
import { loginPrimeiroAcesso } from 'src/api/auth'
import { LoginPrimeiroAcessoQuery } from 'src/types'
import useAuth from 'src/hooks/useAuth'
import Swal from 'sweetalert2'
import { TextField } from '../../components/ui/TextField'
import yup from '../../components/yupCustom'
import { SynPerfis } from 'src/core/consts/synPerfis'

const useStyles = makeStyles(theme => ({
  loginContainer: {
    width: '100vw',
    minWidth: '100vw',
    height: '100vh',
    margin: 0,
    background: '#374666',
    padding: 0
  },
  loginBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: '#fff',
    borderRadius: '8px',
    width: '480px',
    boxSizing: 'border-box',
    padding: '40px',
    margin: '40px auto 0'
  },
  logo: {
    margin: theme.spacing(1),
    width: 80
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  [theme.breakpoints.down('sm')]: {
    loginBox: {
      borderRadius: '0',
      width: '100%',
      height: '100%',
      padding: '40px',
      margin: 0
    }
  }
}))

const schema = yup.object().shape({
  cpf: yup.string().required().label('CPF')
})

export default function ValidarPrimeiroAcessoPage() {
  const classes = useStyles()
  const history = useHistory()
  const { codigo: paramCodigo } = useParams<{ codigo?: string }>()
  const { signed, perfilAtual, setUserSyn } = useAuth()
  const [loading, setLoading] = useState<boolean>(false)

  const {
    control,
    errors,
    watch,
    handleSubmit
  } = useForm<LoginPrimeiroAcessoQuery>({
    mode: 'all',
    resolver: yupResolver(schema),
    defaultValues: { cpf: localStorage.getItem('primeiro_acesso_cpf') || '', codigo: paramCodigo || '' }
  })

  const command = watch()

  useEffect(() => {
    if (signed) {
      if (perfilAtual === SynPerfis.SECRETARIA) {
        history.push(SynRoutes.listagemOrcamentos)
      } else {
        history.push(SynRoutes.home)
      }
    }
  }, [signed, perfilAtual, history])

  function handleKeyDownEnter(e) {
    if (e.key === 'Enter') {
      handleSubmit(onSubmit)()
    }
  }

  const onSubmit = async (data: LoginPrimeiroAcessoQuery) => {
    if (!paramCodigo) {
      Swal.fire('Atenção', 'Acesse esta página através do link enviado para o seu WhatsApp.', 'warning')
      return
    }

    setLoading(true)
    try {
      const payload = { ...data, codigo: paramCodigo }
      const response = await loginPrimeiroAcesso(payload)
      // The backend returns a LoginResponse, which contains Token, Usuario, etc.
      // We need to save it to context similar to how signIn does.
      if (response.data) {
         setUserSyn(response.data)
         // Assuming signed effect will trigger redirection
      }
    } catch (e) {
      const errorMsg = e?.response?.data?.erros?.[0] || e?.response?.data?.mensagem || 'Erro ao validar acesso'
      Swal.fire('Ops...', errorMsg, 'error')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container
      component="main"
      maxWidth="xs"
      className={classes.loginContainer + ' fadeInTransition'}
    >
      <CssBaseline />
      <div className={classes.loginBox}>
        <img
          src="/image/logo-vertical.png"
          className={classes.logo}
          alt="logo syn saúde"
        />
        <Typography component="h1" variant="h6" style={{ marginBottom: 16 }}>
          Validar Primeiro Acesso
        </Typography>
        <Typography variant="body2" align="center" style={{ marginBottom: 16 }}>
          Informe seu CPF e o código recebido no WhatsApp para entrar.
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
          <TextField
            mask={'999.999.999-99'}
            control={control}
            value={command.cpf}
            onKeyDown={handleKeyDownEnter}
            erro={errors}
            name="cpf"
            type="tel"
            label="CPF"
          />
          <Button
            loading={loading}
            disabled={loading}
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Entrar
          </Button>
          <Box textAlign="center">
            <Link
              color="secondary"
              variant="body2"
              onClick={() => history.push(SynRoutes.primeiroAcessoSolicitar)}
              component="button"
              type="button"
            >
              Não recebeu o código? Solicite aqui
            </Link>
          </Box>
          <Box textAlign="center" mt={1}>
            <Link
              color="secondary"
              variant="body2"
              onClick={() => history.push(SynRoutes.signin)}
              component="button"
              type="button"
            >
              Voltar para o Login
            </Link>
          </Box>
        </form>
      </div>
    </Container>
  )
}
